/** @format */

// 设置文档主题
export const setDocumentTheme = (theme = 'white') => {
	const docElm = document.documentElement;
	docElm.setAttribute('theme', theme);
};

/**
 * 复制文本
 * @param text
 */
export const copyText = (text: string) => {
	return new Promise((resolve) => {
		const copyInput = document.createElement('textarea'); //创建一个input框获取需要复制的文本内容
		copyInput.value = text;
		document.body.appendChild(copyInput);
		copyInput.select();
		document.execCommand('copy');
		copyInput.remove();
		resolve(true);
	});
};

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
	if (!element || !className) {
		return;
	}
	let classString = element.className;
	const nameIndex = classString.indexOf(className);
	if (nameIndex === -1) {
		classString += `${className}`;
	} else {
		classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
	}
	element.className = classString;
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
	return !!ele.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
	if (!hasClass(ele, cls)) ele.className += ` ${cls}`;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
	if (hasClass(ele, cls)) {
		const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`);
		ele.className = ele.className.replace(reg, ' ');
	}
}

/**
 * 动态设置页面的 favicon
 * @param faviconUrl favicon 地址
 */
export function setDocumentFavicon(faviconUrl: string) {
	const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');

	link.type = 'image/x-icon';

	link.rel = 'shortcut icon';

	link.href = faviconUrl;

	document.getElementsByTagName('head')[0].appendChild(link);
}

/**
 *
 * 注入 css 到 iframe 用来统一样式
 * @param document 当前的 document
 * @param iframeId iframeId
 * @param cssUrl css 地址
 * @param linkId css linkId
 */
export function injectCssToIframeDocument(
	document: Document,
	iframeId: string,
	cssUrl: string,
	linkId = 'commonstyle',
) {
	if (!cssUrl) {
		return;
	}
	const componyRelIframe = document.getElementById(iframeId);
	const iframeDoc = (componyRelIframe as any)?.contentWindow?.document;
	injectCssToDocument(iframeDoc, cssUrl, linkId);
}

/**
 *
 * 注入 css 到 document 用来统一样式
 * @param document 被注入 css 的 document
 * @param cssUrl css 地址
 * @param linkId css linkId
 */
export function injectCssToDocument(document: Document, cssUrl: string, linkId = 'commonstyle') {
	if (!cssUrl) {
		return;
	}
	const linkItem = document.getElementById(linkId);
	if (linkItem) {
		return;
	}
	const iframeHead = document.getElementsByTagName('head');
	const linkTag = document.createElement('link');
	linkTag.id = linkId;
	linkTag.href = cssUrl;
	linkTag.setAttribute('rel', 'stylesheet');
	linkTag.setAttribute('type', 'text/css');
	iframeHead[0].appendChild(linkTag);
}

/**
 *
 * 注入 js 到 document 用来统一处理一些定制化功能
 * @param document 被注入 js 的 document
 * @param jsUrl js 地址
 * @param linkId js linkId
 */
export function injectJsToDocument(document: Document, jsUrl: string, linkId = 'commonjs') {
	if (!jsUrl) {
		return;
	}
	const linkItem = document.getElementById(linkId);
	if (linkItem) {
		return;
	}
	const iframeHead = document.getElementsByTagName('head');
	const linkTag = document.createElement('script');
	linkTag.id = linkId;
	linkTag.src = jsUrl;
	iframeHead[0].appendChild(linkTag);
}

/**
 * title 超长后鼠标移上去 span 或 div 显示 title ，否则不显示
 * @param title title 的内容
 * @param length title 的长度超过 length 后显示 title 否则不显示，length 默认为 5
 * @return 要显示的 title 或 ''
 */
export function hasTitle(title: string | null | undefined, length = 5): string {
	if (!title) {
		return '';
	}
	if (title.length > length) {
		return title;
	} else {
		return '';
	}
}

export const openWindow = (url, target = '_blank', windowFeatures = '') => {
	// const newWindow = window.open(url, target, `noreferrer,noopener${windowFeatures ? `,${windowFeatures}` : ''}`);
	// if (newWindow) newWindow.opener = null;
	window.open(url, target, `${windowFeatures ? `,${windowFeatures}` : ''}`);
};
